import { render } from "./IconInventory.vue?vue&type=template&id=3d678925"
import script from "./IconInventory.vue?vue&type=script&lang=ts"
export * from "./IconInventory.vue?vue&type=script&lang=ts"
script.render = render

export default script